import { replaceMathTags } from 'util/string';

export default function CkeditorReadonly({ data, id = "idShouldUnique" }) {
  // return replaceMathTags(data);
  return <div dangerouslySetInnerHTML={{ __html: data }} className="ckeditor-readonly-container" />;
}
